import { Component } from '@ecs/Component';

export class ViewportEntry implements Component {
  readonly type = 'ViewportEntry';

  constructor(
    public hasEntered: boolean = false
  ) {}
}